import styled from 'styled-components';
import { color, container, radius, screen, spacing } from 'theme';
import { getPublicPath } from 'utils/paths';

export const StyledWrapper = styled.div`
  background-image: ${() =>
    `url('${getPublicPath('/images/memberGetMember/bg-info.svg')}')`};
  background-repeat: no-repeat;
  padding: ${spacing('xl4')} 0;
  background-size: cover;
  background-position: center bottom;
`;

export const StyledContainer = styled.div`
  margin: auto;
  padding: ${spacing('xl2')} ${spacing('md')};
  color: ${color('white')};
`;

export const StyledHeader = styled.div`
  text-align: center;
  max-width: ${container('md')};
  margin: auto;

  p {
    margin-top: ${spacing('lg')};
    margin-bottom: ${spacing('xl')};
  }
`;

export const StyledItems = styled.div`
  max-width: ${container('md')};
  margin: ${spacing('xl3')} auto;
  display: grid;
  gap: ${spacing('lg')};
  grid-template-columns: minmax(0, 1fr);

  @media (min-width: ${screen('md')}) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
`;

export const StyledItem = styled.a`
  color: inherit;
  background-color: ${color('indigo_700')};
  padding: ${spacing('md')};
  border-radius: ${radius('md')};
  display: flex;
  align-items: center;
  gap: ${spacing('xs')};
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.8;
    color: inherit;
  }
`;
